import { AxiosHttpClient } from '../../../infra/http'
import { settings } from '../../configs/settings'

export const makeAxiosHttpClient = () => {
  return new AxiosHttpClient(settings.API_URL)
}
